import { render } from "./annual-report-count.vue?vue&type=template&id=e60ed546&scoped=true"
import script from "./annual-report-count.vue?vue&type=script&lang=js"
export * from "./annual-report-count.vue?vue&type=script&lang=js"

import "./annual-report-count.vue?vue&type=style&index=0&id=e60ed546&scoped=scoped&lang=less"

import exportComponent from "D:\\project\\BidData\\code\\xyf_web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e60ed546"]])

export default __exports__